<template>
  <div class="bb-default-page-listen-content">
    <c-module-page-listen-content />
    <div :class="{ 'pa-0 mb-3': $voicer.isDesktopOrTablet }">
      <b-footer :no-padding="$voicer.isDesktopOrTablet" />
    </div>
  </div>
</template>

<script>
import CModulePageListenContent from './pages/listen-content/index.vue'

import navigationGuard from '~/mixins/navigationGuard'
import pageHead from '~/mixins/pageHead'

export default {
  components: {
    CModulePageListenContent,
  },
  mixins: [pageHead, navigationGuard],
  scrollToTop: true,
  data() {
    return {
      /**
       * relative module rendered (depending device mode)
       */
      cModule: this.$voicer.isMobile ? 'c-module-mobile' : 'c-module-desktop',
    }
  },
}
</script>
